import React from "react";
import { ChartConfig } from "@/components/ui/Chart";
import { Payload } from "recharts/types/component/DefaultLegendContent";

export const Legend = ({
  chart,
  config,
}: {
  chart: { payload?: Payload[] };
  config: ChartConfig;
}) => {
  const { payload } = chart;
  return (
    <div className="mb-4 flex flex-wrap justify-end gap-x-10 gap-y-2 text-foreground">
      {payload?.map((entry, index) => {
        const { color, dataKey } = entry;
        const key = dataKey?.toString() || "";
        const lineConfig = config[key] || {};
        if (!lineConfig.hide) {
          return (
            <div
              key={`legend-item-${index}`}
              className="flex items-center gap-2"
            >
              {!lineConfig.dashed ? (
                <span
                  className="h-1 w-5 rounded-full"
                  style={{ backgroundColor: color }}
                />
              ) : (
                <div className="flex gap-[3px]">
                  <span
                    className="h-1 w-2 rounded-full"
                    style={{ backgroundColor: color }}
                  />
                  <span
                    className="h-1 w-2 rounded-full"
                    style={{ backgroundColor: color }}
                  />
                </div>
              )}
              <span>{key}</span>
            </div>
          );
        }
      })}
    </div>
  );
};
